import { ChevronUpIcon, EyeIcon } from '@heroicons/react/outline'
import { ChevronDownIcon } from '@heroicons/react/outline'
import { useState } from 'react'

import { ManagementOrganizationMembership, UserBaseInfo } from 'types/userTypes'

import MemberDropdownSection from 'components/common/NavigationDropdownMenu/MemberDropdownSection'
import MembershipsDropdownSection from 'components/common/NavigationDropdownMenu/MembershipsDropdownSection'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { old_COLOR } from 'styles/constants/old_color'
import { old_FONT_SIZE } from 'styles/constants/old_fontSize'
import { old_SPACE } from 'styles/constants/old_space'

import Box from '../Box/Box'
import Button from '../Button/Button'
import FlexBox from '../FlexBox/FlexBox'
import DropdownMenuItem, { MenuItem } from './NavigationDropdownMenuItem'

type Props = {
  menuName: string
  menuItems: MenuItem[]
  managementOrganizationMemberships: ManagementOrganizationMembership[]
  members: UserBaseInfo[]
  currentOrganization?: string
  isViewOnly?: boolean
}

export default function NavigationDropdownMenu({
  menuName,
  menuItems,
  members,
  managementOrganizationMemberships,
  currentOrganization,
  isViewOnly,
}: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const selectedViewOnlyOrganization = managementOrganizationMemberships.find(
    (membership) => membership.managementOrganizationId === currentOrganization
  )

  return (
    <Box position="relative">
      <Button onClick={() => setIsOpen(!isOpen)} variant="tertiary">
        <FlexBox color={old_COLOR.coolGray600}>
          <FlexBox
            flexDirection="column"
            gap={old_SPACE.sp4}
            marginRight={old_SPACE.sp8}
          >
            <PDSText fontSize={FONT_SIZE.fs14} weight="semibold">
              {menuName}
            </PDSText>
            {isViewOnly && (
              <FlexBox
                style={{
                  fontSize: old_FONT_SIZE.fs12,
                  fontWeight: 500,
                  color: old_COLOR.coolGray500,
                }}
                gap={old_SPACE.sp2}
                justifyContent="flex-end"
                alignItems="center"
              >
                <EyeIcon width={old_SPACE.sp14} height={old_SPACE.sp14} />
                <span>
                  View-Only
                  {selectedViewOnlyOrganization &&
                    ` - ${selectedViewOnlyOrganization?.firstName} ${selectedViewOnlyOrganization?.lastName}`}
                </span>
              </FlexBox>
            )}
          </FlexBox>

          <Box width="1.25rem">
            {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </Box>
        </FlexBox>
        {isOpen && (
          <Box
            backgroundColor={old_COLOR.white}
            border={`1px solid ${old_COLOR.coolGray300}`}
            borderRadius="0.5rem"
            boxShadow={`inset 0 0 1px 1px ${old_COLOR.coolGray300}`}
            left="-5rem"
            top="2.5rem"
            padding={old_SPACE.sp8}
            position="absolute"
            width="15rem"
            zIndex={2}
          >
            {menuItems.map((item) => {
              return <DropdownMenuItem key={item.name} item={item} />
            })}

            {managementOrganizationMemberships.length > 0 && (
              <MembershipsDropdownSection
                managementOrganizationMemberships={
                  managementOrganizationMemberships
                }
                currentOrganization={currentOrganization}
              />
            )}

            {members.length > 0 && <MemberDropdownSection members={members} />}
          </Box>
        )}
      </Button>
    </Box>
  )
}
